function declineWord(number, words) {
  const cases = [2, 0, 1, 1, 1, 2];
  return words[number % 100 > 4 && number % 100 < 20 ? 2 : cases[Math.min(number % 10, 5)]];
}

export function formatTime(disconnectTime) {
  if (!disconnectTime) return 'неизвестно';

  const now = new Date();
  const diffMs = now - new Date(disconnectTime);
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);

  if (diffMinutes < 60) {
    return `был в сети ${diffMinutes} ${declineWord(diffMinutes, ['минута', 'минуты', 'минут'])} назад`;
  }

  if (diffHours < 24) {
    return `был в сети ${diffHours} ${declineWord(diffHours, ['час', 'часа', 'часов'])} назад`;
  }

  return `был в сети ${new Date(disconnectTime).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })}`;
}
